var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6591 17.9286C10.8968 19.0715 9.94478 19.6429 8.80192 19.6429C7.65907 19.6429 6.70707 19.0715 5.94478 17.9286M14.6134 16.2143H2.99049C2.65659 16.2145 2.32864 16.126 2.04015 15.9579C1.75166 15.7897 1.51298 15.548 1.34851 15.2575C1.18404 14.9669 1.09968 14.6378 1.10404 14.304C1.10841 13.9701 1.20134 13.6434 1.37335 13.3572C2.49499 11.4878 3.08753 9.34869 3.08764 7.16861V5.92861C3.08764 4.71619 3.56927 3.55343 4.42658 2.69612C5.28389 1.83881 6.44665 1.35718 7.65907 1.35718H9.94478C11.1572 1.35718 12.32 1.83881 13.1773 2.69612C14.0346 3.55343 14.5162 4.71619 14.5162 5.92861V7.16861C14.5162 9.34804 15.1082 11.4886 16.2305 13.3572C16.4025 13.6434 16.4954 13.9701 16.4998 14.304C16.5042 14.6378 16.4198 14.9669 16.2553 15.2575C16.0909 15.548 15.8522 15.7897 15.5637 15.9579C15.2752 16.126 14.9473 16.2145 14.6134 16.2143Z",
    stroke: "#64748B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.7ceb6c6402f3a5394b0047a7c88be3d8.svg";
export { ForwardRef as ReactComponent };